export const prodConfig = {
  ManagerServer: {
    rest: {
      port: 9093,
      hostname: "37.187.19.119",
      url: "https://wyniki-online.pl:9093",
    },
  },
}
